<template>
  <div class="moduleClick-box">
    <div class="action-bar">
      <el-select
        v-model="params.moduleId"
        clearable
        filterable
        placeholder="请选择模块"
        size="small"
        class="param-input"
        @change="getList('status')"
      >
        <el-option
          v-for="item in moduleOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
      >搜索</el-button>
    </div>
    <el-table
      height="auto"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="sumDate" label="统计日期" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.sumDate | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="moduleId" label="模块ID" align="center" min-width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.moduleId || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="moduleName" label="模块名称" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="moduleType" label="模块类型" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ formatModuleType(scope.row.moduleType) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="clickCount" label="点击数" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.clickCount || 0 }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>

<script>
import API from "@/api";
import { changeTime } from "@/utils/global";

const MODULE_TYPE_MAP = {
  0: "首页",
  1: "帖子",
  2: "暗网",
  3: "图集",
  4: "短视频",
};

export default {
  data() {
    return {
      loading: false,
      time: "",
      total: 0,
      tableData: [],
      moduleOptions: [],
      params: {
        pageNumber: 1,
        pageSize: 20,
        moduleId: "",
        startTime: "",
        endTime: "",
      },
    };
  },
  created() {
    const [start, end] = this.getTodayAndTomorrow();
    this.time = [start, end];
    this.params.startTime = changeTime(start);
    this.params.endTime = changeTime(end);
    this.getModuleOptions();
    this.getList();
  },
  methods: {
    getTodayAndTomorrow() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return [today, tomorrow];
    },
    formatModuleType(type) {
      if (type === null || type === undefined || type === "") {
        return "未知";
      }
      return MODULE_TYPE_MAP[type] || type;
    },
    getModuleOptions() {
      API.getModuleList({
        pageNumber: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.code !== 200 || !res.data) {
          this.moduleOptions = [];
          return;
        }
        const options = [];
        res.data.forEach((parent) => {
          if (parent.list && parent.list.length) {
            parent.list.forEach((item) => {
              options.push({
                value: item.moduleID || item.id,
                label: `${parent.moduleName || ""} / ${item.moduleName || ""}`,
              });
              if (item.subModules && item.subModules.length) {
                item.subModules.forEach((sub) => {
                  options.push({
                    value: sub.id,
                    label: `${parent.moduleName || ""} / ${item.moduleName || ""} / ${sub.moduleName || ""}`,
                  });
                });
              }
            });
          }
        });
        this.moduleOptions = options;
      });
    },
    getList(type) {
      if (type) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getModuleStat(this.params)
        .then((res) => {
          if (res.code === 200 && res.data && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.total = 0;
          this.loading = false;
        });
    },
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getList();
    },
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getList("status");
    },
  },
};
</script>

<style lang="scss">
.moduleClick-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .el-pagination {
    align-self: flex-end;
    flex-shrink: 0;
    margin-top: 10px;
  }
}
</style>
